/* eslint-disable import/no-extraneous-dependencies */
import classNames from 'classnames';
import styles from './Landing.module.css';
import useAuth from 'src/hooks/useAuth';

const Landing = () => {
  const { login } = useAuth();

  return (
    <div
      className="image-button-container"
      style={{ position: 'relative', display: 'inline-block' }}
    >
      <img src="/JLR_VFDB.png" alt="Image Preview" style={{ display: 'block', width: '100%' }} />
      <div
        className={classNames(styles['Landing--ButtonContainer'])}
        style={{
          position: 'absolute',
          top: '30%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <button className={classNames(styles['Landing--Button'])} onClick={login}>
          Log In
        </button>
      </div>
    </div>
  );
};
export default Landing;
